import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Settings from './components/Settings';
function AiInspectionManager(props) {
    var _a, _b, _c;
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(Settings, { accounts: (_a = props.accounts) !== null && _a !== void 0 ? _a : [], buildingTags: (_b = props.buildingTags) !== null && _b !== void 0 ? _b : [], accountTags: (_c = props.accountTags) !== null && _c !== void 0 ? _c : [] })));
}
export default AiInspectionManager;
